import * as React from "react";
import { TextField, MenuItem, withStyles } from "@material-ui/core";
import i18n from "i18n";
import NumberField from "common/components/fields/NumberField";
import { useState } from "react";

const styles = () => ({
  containerSelects: {
    display: "flex",
    paddingBottom: "15px",
  },
  selectDate: {
    width: "50%",
    marginBottom: "5px",
    maxHeight: "300px",

    "&:last-of-type": {
      marginLeft: "5px",
    },
  },
  menu: {
    maxHeight: "350px",
    marginTop: "47px",
  },
  inputInfo: {
    width: "100%",
    marginBottom: "25px",
  },
});

const months = i18n.months;
const years = (function () {
  const currentYear = new Date().getFullYear();
  const years: number[] = [];
  for (let year = currentYear - 10; year <= currentYear + 15; year++) {
    years.push(year);
  }
  return years;
})();

const Properties = ({
  classes,
  containerClass,
  data,
  onDateChange,
  onInputChange,
}) => {
  const i18nLabel = i18n.project.rightSideMenu.WBSInfo;
  const date = data.baseDate || new Date();
  const [month, setMonth] = useState(date.getMonth());
  const [year, setYear] = useState(date.getFullYear());

  const handleMonthChange = (ev) => {
    const value = ev.target.value;
    setMonth(value);
    changeBaseDate(value, year);
  };

  const handleYearChange = (ev) => {
    const value = ev.target.value;
    setYear(value);
    changeBaseDate(month, value);
  };

  const changeBaseDate = (newMonth, newYear) => {
    const monthStr = ("0" + (newMonth + 1)).slice(-2);
    const date = new Date(`${newYear}-${monthStr}-01T12:00:00Z`);
    onDateChange(date);
  };

  return (
    <div className={containerClass}>
      <div className={classes.containerSelects}>
        <TextField
          className={classes.selectDate}
          label={i18nLabel.monthBase}
          select
          value={month}
          onChange={handleMonthChange}
          SelectProps={{
            MenuProps: {
              className: classes.menu,
            },
          }}
          InputLabelProps={{
            shrink: true,
          }}
        >
          {months.map((option, index) => (
            <MenuItem key={index} value={index}>
              {option}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          className={classes.selectDate}
          select
          value={year}
          onChange={handleYearChange}
          SelectProps={{
            MenuProps: {
              className: classes.menu,
            },
          }}
        >
          {years.map((option, index) => (
            <MenuItem key={index} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>
      </div>

      <NumberField
        id="inputProjectTerm"
        name="projectTerm"
        className={classes.inputInfo}
        label={i18nLabel["monthRelease"]}
        labelOnFocus={i18nLabel["monthReleaseFocus"]}
        value={data.project.projectTerm}
        onInputBlur={onInputChange}
      />

      <NumberField
        id="inputLandArea"
        name="landArea"
        className={classes.inputInfo}
        label={i18nLabel["landArea"]}
        labelOnFocus={i18nLabel["landAreaFocus"]}
        value={data.project.landArea}
        onInputBlur={onInputChange}
      />

      <NumberField
        id="inputprivateUnits"
        name="privateUnits"
        className={classes.inputInfo}
        label={i18nLabel["privateUnits"]}
        labelOnFocus={i18nLabel["privateUnitsFocus"]}
        value={data.project.privateUnits}
        onInputBlur={onInputChange}
      />
      <NumberField
        id="inputBuiltArea"
        name="builtArea"
        className={classes.inputInfo}
        label={i18nLabel["builtArea"]}
        labelOnFocus={i18nLabel["builtAreaFocus"]}
        value={data.project.builtArea}
        onInputBlur={onInputChange}
      />
      <NumberField
        id="inputEquivalentArea"
        name="equivalentArea"
        className={classes.inputInfo}
        label={i18nLabel["equivalentArea"]}
        labelOnFocus={i18nLabel["equivalentAreaFocus"]}
        value={data.project.equivalentArea}
        onInputBlur={onInputChange}
      />
      <NumberField
        id="inputPrivateArea"
        name="privateArea"
        className={classes.inputInfo}
        label={i18nLabel["privateArea"]}
        labelOnFocus={i18nLabel["privateAreaFocus"]}
        value={data.project.privateArea}
        onInputBlur={onInputChange}
      />
    </div>
  );
};

export default withStyles(styles)(Properties);



// WEBPACK FOOTER //
// ./src/modules/projectRightMenu/components/layouts/WBSProperties/Properties.tsx